module.exports = __webpack_public_path__ + "static/img/bg-pt.11e73b27.png";